import { CameraAlt } from "@mui/icons-material";
import { Button, Container, Drawer } from "@mui/material";
import { formatCurrency } from "common";
import { H5 } from "components/Typography";
import { FlexBox } from "components/flex-box";
import { useAppSelector } from "hooks/use-app-selector";
import modules from "modules";
import { FC } from "react";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BackspaceOutlinedIcon from "@mui/icons-material/BackspaceOutlined";
import { useLoginStatus } from "hooks/useLoginStatus";
import { useDialogueShow } from "hooks/useDialogue";
import { userBuildFlag } from "common/constants/feature-toggles";

type Props = {
  isBuildDrawerOpen?: boolean;
  isBuildIncomplete?: boolean;
  saveString?: string;
  handleBuildDrawerClose?: () => void;
  onScreenShotMobile?: () => void;
  handleSaveBuild?: () => void;
  onClickClearAll?: () => void;
  toggleDecision?: () => void;
};

const { selectors: pcBuilderSelectors } = modules.pcBuilder;

export const MobileBuildDrawer: FC<Props> = ({
  isBuildDrawerOpen,
  isBuildIncomplete,
  saveString,
  handleBuildDrawerClose,
  onScreenShotMobile,
  handleSaveBuild,
  onClickClearAll,
  toggleDecision,
}) => {
  const totalAmount = useAppSelector(
    pcBuilderSelectors.selectBuildPartsTotalAmount
  );
  const { showLoginFormOpen } = useDialogueShow();
  const { isUserLogin } = useLoginStatus();
  
  const isLogin = isUserLogin

  return (
    <Drawer
      anchor={"bottom"}
      open={isBuildDrawerOpen}
      onClose={handleBuildDrawerClose}
    >
      <Container
        sx={{
          padding: 2,
          textAlign: "left",
        }}
      >
        <FlexBox alignItems="center" marginBottom={1}>
          <H5 fontWeight={600}>{"SUBTOTAL"}</H5>
          <H5 marginLeft={5} fontWeight={600}>
            {formatCurrency(totalAmount)}
          </H5>
        </FlexBox>
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<CameraAlt />}
          onClick={onScreenShotMobile}
          sx={{
            justifyContent: "flex-start",
            width: "inherit",
            fontSize: 12,
            marginBottom: 1,
          }}
        >
          Take a Screenshot
        </Button>
        {userBuildFlag ? (
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<BookmarkBorderIcon />}
            onClick={handleSaveBuild}
            disabled={isBuildIncomplete}
            sx={{
              justifyContent: "flex-start",
              width: "inherit",
              fontSize: 12,
              marginBottom: 1,
            }}
          >
            {saveString}
          </Button>
        ) : null}
        <Button
          variant="outlined"
          color="primary"
          startIcon={<BackspaceOutlinedIcon />}
          onClick={onClickClearAll}
          sx={{
            justifyContent: "flex-start",
            width: "inherit",
            fontSize: 12,
            marginBottom: 1,
          }}
        >
          Clear Build
        </Button>
        {totalAmount ? (
          <Button
            disabled={!totalAmount}
            color="secondary"
            variant="contained"
            style={{ borderRadius: 4 }}
            sx={{
              height: 30,
              paddingLeft: 4,
              paddingRight: 4,
              bgcolor: "#CF151A",
              width: "inherit",
            }}
            onClick={isLogin ? toggleDecision : showLoginFormOpen}
          >
            ADD TO CART
          </Button>
        ) : null}
      </Container>
    </Drawer>
  );
};
